import { HomeApi } from "@/zh-website/src/views/Homes/api";
import { BaseAbstractService } from "@common/service/base-service/global";
import RequestService from "@common/service/base-service/request/ICT2BRequest";

export class HomeService extends BaseAbstractService {
  static getBanner(query) {
    return HomeApi.getBanner(this.request, query);
  }
  static getSuccessCase(query) {
    return HomeApi.getSuccessCase(this.request, query);
  }
  static getNewArrival(query) {
    return HomeApi.getNewArrival(this.request, query);
  }
  static getNewArrivalDetail(query) {
    return HomeApi.getNewArrivalDetail(this.request, query);
  }
  static getDynamic(query) {
    return HomeApi.getDynamic(this.request, query);
  }
  static getDynamicTogether(query) {
    return HomeApi.getDynamicTogether(this.request, query);
  }
  static getProductList(query) {
    return HomeApi.getProductList(this.request, query);
  }
  static createFeedback(query) {
    return HomeApi.createFeedback(this.request, query);
  }
  static getCode() {
    return HomeApi.getCode(this.request);
  }
  static privacyPersonal(data) {
    return HomeApi.privacyPersonal(this.request,data);
  }
}
HomeService.setRequest(RequestService);
